import React from 'react';

/**
 * 의뢰구분(협회/비협회) 배지 — 관리자(lab) 화면과 동일한 색/아이콘을 사용한다.
 *
 * 파트너 포털은 Amber 테마지만, 이 배지는 브랜드가 아니라 "의뢰 경로"라는 의미를
 * 나타내는 값이다. 두 포털에서 같은 값이 다른 색으로 보이면 같은 시험을 두고
 * 관리자와 의뢰사가 서로 다른 인상을 갖게 되므로 색은 의도적으로 통일한다.
 *   협회   = 보라 (🏛️) — 협회를 경유해 접수된 시험
 *   비협회 = 청록 (🏢) — 의뢰사가 직접 접수한 시험
 */
export const REQUEST_TYPE_META: Record<string, { color: string; bg: string; border: string; icon: string }> = {
  '협회':   { color: '#7c3aed', bg: '#f5f3ff', border: '#c4b5fd', icon: '🏛️' },
  '비협회': { color: '#0d9488', bg: '#f0fdfa', border: '#99f6e4', icon: '🏢' },
};

const RequestTypeBadge: React.FC<{ value?: string | null; size?: 'sm' | 'md' }> = ({ value, size = 'sm' }) => {
  // 값이 비어 있으면 '비협회'로 본다 — DB 기본값과 동일한 해석.
  const key = value === '협회' ? '협회' : '비협회';
  const m = REQUEST_TYPE_META[key];
  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', gap: 3,
      padding: size === 'sm' ? '0 7px' : '2px 10px',
      borderRadius: 999,
      fontSize: size === 'sm' ? 11 : 12, fontWeight: 700,
      color: m.color, background: m.bg, border: `1px solid ${m.border}`,
      lineHeight: size === 'sm' ? '18px' : '20px', whiteSpace: 'nowrap',
    }}>
      <span style={{ fontSize: size === 'sm' ? 10 : 12, lineHeight: 1 }}>{m.icon}</span>
      {key}
    </span>
  );
};

export default RequestTypeBadge;
